import { inject, Injector, runInInjectionContext } from '@angular/core';
import { IdentiteService } from '@idt-api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { getApprenantUUID } from '@pcscol-portail/ng-auth';
import { getStructureSelected } from '@pcscol-portail/ng-authz';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { piecesJustificativesActions } from '@app/features/pieces-justificatives/store/pieces-justificatives.actions';
import { IdtActions } from './idt.actions';

/**
 * Listen to establishment selection and trigger lireIdentite
 */
export const onStructureSelected$ = createEffect(
  (store = inject(Store)) =>
    store.select(getStructureSelected).pipe(
      filter((structure) => !!structure?.code),
      map(() => IdtActions.lireIdentite()),
    ),
  { functional: true },
);

/**
 * Load identite from API
 */
export const lireIdentite$ = createEffect(
  (actions$ = inject(Actions), store = inject(Store), injector = inject(Injector)) =>
    actions$.pipe(
      ofType(IdtActions.lireIdentite),
      switchMap(() =>
        runInInjectionContext(injector, () => {
          const identiteService = inject(IdentiteService);

          const structureCode = store.selectSignal(getStructureSelected)()?.code;
          const rawIdentifiant = store.selectSignal(getApprenantUUID)();
          const identifiantApprenantPegase = rawIdentifiant?.includes('@@')
            ? rawIdentifiant.split('@@')[1]
            : rawIdentifiant;

          if (!structureCode || !identifiantApprenantPegase) {
            return of(
              IdtActions.lireIdentiteFailure({
                error: 'Structure code or apprenant UUID is missing',
              }),
            );
          }

          return identiteService.lireIdentite(structureCode, identifiantApprenantPegase).pipe(
            map((identite) => IdtActions.lireIdentiteSuccess({ identite })),
            catchError((error) => of(IdtActions.lireIdentiteFailure({ error }))),
          );
        }),
      ),
    ),
  { functional: true },
);

/**
 * Load pieces after identite is successfully loaded
 */
export const onIdentiteLoaded$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(IdtActions.lireIdentiteSuccess),
      map(() => piecesJustificativesActions.loadPieces()),
    ),
  { functional: true },
);
